import API from '@/common/modules/api'



// ----------------------
// localStorage helper
// ----------------------

const Storage = {

    get (key) {
        const json = localStorage.getItem(key);
        try { return JSON.parse(json) }
        catch (e) { return null }
    },

    set (key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },

    remove (key) {
        localStorage.removeItem(key);
    }

};



// ------------------
// Store
// ------------------

export default {

    namespaced: true,

    state: {
        account: null,
        token: Storage.get('token') || {},
        refreshing: null
    },

    getters: {

        exists (state) {
            return state.token.jwt && state.token.refresh;
        }

    },

    mutations: {

        token (state, token) {
            state.token.jwt = token;
            Storage.set('token', JSON.stringify(state.token));
        }

    },

    actions: {

        init ({getters, dispatch}) {
            if (!getters.exists) return dispatch('destroy');
            dispatch('update');
        },

        async update ({state}) {
            const {data} = await API('me');
            state.account = data;
            Storage.set('account', data);
        },

        create ({state, dispatch}, token) {
            state.token = token;
            Storage.set('token', token);
            return dispatch('init');
        },

        refresh ({state, commit, dispatch}) {
            if (state.refreshing) return state.refreshing;

            return state.refreshing = API('refresh', state.token.refresh)
                .then(({data: {token}}) => {
                    commit('token', token);
                    return token;
                })
                .catch(() => dispatch('destroy'))
                .finally(() => state.refreshing = null);
        },

        destroy () {
            API.abort();
            Storage.remove('token');
            Storage.remove('account');
            window.location.href = AUTH_ORIGIN + '?app_id=' + APP_ID;
            return Promise.reject();
        }

    }

};

